import React, { useState } from 'react';
import './NoteList.scss';
import NoteInputArea from '..//Note/NoteInputArea';
import NoteDisplayArea from '..//Note/NoteDisplayArea';
import { Note } from '../../interfaces/Notes/note';
import { useLazyLoading } from '../_common';
import {  ToastContainer, toast } from 'react-toastify';

interface NoteListProps {
    noteItems: Note[];
    onSaveNote: (noteText: string) => void;
    onEditNote: (noteText: string, noteId: number) => void;
    isLoading: boolean;
    isEndOfResults: boolean;
    canAddNewNotes: boolean;
    canViewNotesList: boolean;
    onLoadMore: () => void;
    canEditNote?: boolean;
}

const NoteList = ({
    noteItems,
    onSaveNote,
    onEditNote,
    isLoading,
    isEndOfResults,
    onLoadMore,
    canAddNewNotes,
    canViewNotesList,
    canEditNote,
}: NoteListProps): React.ReactElement => {
    const [noteOnEdit, setNoteOnEdit] = useState(false);
    const { handleScroll } = useLazyLoading('notesList', isLoading, isEndOfResults, onLoadMore);

    const onSaveClick = (note: string): void => {
        onSaveNote(note);
    };

    const onEditClick = (note: string, noteId: number): void => {
        onEditNote(note, noteId);
    };

    return (
        <div className="NoteList-Container">
            <ToastContainer />
            {canAddNewNotes && (
                <React.Fragment>
                    <div className="NoteList-AddComment">Add Comment</div>
                    <NoteInputArea onSaveNote={onSaveClick} onEditNote={onEditClick} />
                </React.Fragment>
            )}
            {canViewNotesList && (
                <div className="NoteList-ExistingNotes" id="notesList" onScroll={handleScroll}>
                    {noteItems.map(
                        (noteItem: Note, index: number): React.ReactElement => {
                            return (
                                <NoteDisplayArea
                                    key={noteItem.noteId}
                                    note={noteItem}
                                    noteOnEditMode={(onEditMode): void => {
                                        setNoteOnEdit(onEditMode);
                                    }}
                                    onEditNote={onEditClick}
                                    index={index}
                                    onDisableMode={noteOnEdit}
                                    canEditNotes={canEditNote || false}
                                />
                            );
                        },
                    )}
                </div>
            )}
        </div>
    );
};

export default NoteList;
